<template>
    <div>
        <headerNav title="详情" />
        
        <div v-if="vinfo" class="vmain">
            <div class="ftit">
                {{vinfo.title}}
            </div>
            <div v-html="vinfo.content" class="content" >
                
            </div>
        </div>
        
    </div>
</template>
<script>
export default {
    data(){
        return{
            myhtml:'',
            vid:undefined,
            vinfo:undefined
        }
    },
    beforeCreate(){
        document.querySelector('body').setAttribute('style', 'background-color:#fff')
    },
    destroyed(){
        document.querySelector('body').removeAttribute("style");
    },
    created()
    {
        var query=this.$route.query;
        if(query.id)
        {
            this.vid=query.id;
            this.queryinfo();
        }
       
    },
    methods:
    {
        queryinfo()
        {
            this.ajax.post('/api/services/app/PhoneWiki/QueryArticle?id='+this.vid).then(x=>
            {
                  x.result.content=x.result.content.replace(/&lt;/g, "<")
          .replace(/&gt;/g, ">")
          .replace(/&amp;/g, "&")
          .replace(/&quot;/g, '"')
          .replace(/&apos;/g, "'");
                    this.vinfo=x.result;
            })
        }
    }
}
</script>
<style scoped>
.ftit{
    font-size: 16px;
    font-weight: bold;
    padding-top: 5px;
    margin-bottom: 5px;
}
.vmain{
    font-size: 14px;
    letter-spacing: 1px;
    background-color: white;
    padding:0 10px;
    
}
.content >>> p{
    line-height: 25px;
}
.content >>> blockquote{
    display: block;
    border-left: 8px solid #d0e5f2;
    padding: 5px 10px;
    margin: 10px 0;
    line-height: 1.4;
    font-size: 100%;
    background-color: #f1f1f1; 
}

</style>